const REQUEST_ID_PATTERN = /\s*\(Request ID:\s*([^)]+)\)/;

/**
 * Extract request ID from error message if present.
 * Returns { message, requestId } where requestId may be null.
 */
const parseErrorMessage = (errorText) => {
  if (!errorText) return { message: null, requestId: null };

  const match = errorText.match(REQUEST_ID_PATTERN);
  if (!match) return { message: errorText, requestId: null };

  return {
    message: errorText.replace(REQUEST_ID_PATTERN, "").trim(),
    requestId: match[1].trim(),
  };
};

export default parseErrorMessage;
